import { render, staticRenderFns } from "./QAuth0Link.vue?vue&type=template&id=591e3d36&scoped=true&"
import script from "./QAuth0Link.vue?vue&type=script&lang=js&"
export * from "./QAuth0Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e3d36",
  null
  
)

export default component.exports